import type { Theme } from '@mui/material';

export const styles = {
  bulkEditRadioGroup: {
    marginBottom: 0.625,
  },
  bulkEditRadioLabel: (theme: Theme) => ({
    ...theme.typography.h6,
    color: theme.colors.neutral[500],
    marginBottom: 1.25,
  }),
  bulkEditRadioControlLabel: {
    marginRight: 3.75,
  },
};
